import StatusMessage from './status-message';

export default StatusMessage;
